import { useParams, useNavigate } from "react-router-dom";
import { useFetchStrapiData } from "../../config/strapiService.js";
import { useEffect, useRef } from "react";
import React from "react";
import { createSlug, PageSkeleton } from "../../config/utils.js";

const CourseRedirect = () => {
	const { subjectSlug, courseSlug } = useParams();
	const { quizData, isLoading, error } = useFetchStrapiData();
	const navigate = useNavigate();
	const mountedRef = useRef(true);

	useEffect(() => {
		mountedRef.current = true;
		const handleRedirect = () => {
			if (!isLoading && quizData && mountedRef.current) {
				try {
					// Get the first unit
					const firstUnit = quizData.units[0];
					if (!firstUnit) {
						console.error("No units available");
						return;
					}

					// Get the first lesson from the first unit
					const firstLesson = firstUnit.lessons[0];
					if (!firstLesson) {
						console.error("No lessons available in the first unit");
						return;
					}

					// Construct the path
					const path = `/courses/${subjectSlug}/${courseSlug}/${createSlug(firstUnit.title)}/${createSlug(firstLesson.title)}/${firstLesson.id}`;
					console.log("Redirecting to:", path);

					// Navigate to the first lesson
					if (mountedRef.current) {
						navigate(path, { replace: true });
					}
				} catch (err) {
					console.error("Error processing data:", err);
				}
			}
		};

		handleRedirect();

		return () => {
			mountedRef.current = false;
		};
	}, [quizData, isLoading, navigate, subjectSlug, courseSlug]);

	if (error) {
		return (
			<div className="error-container">
				<div className="error-message">
					Error loading course: {error}
				</div>
			</div>
		);
	}

	if (isLoading) {
		return <PageSkeleton />;
	}

	if (!quizData) {
		return (
			<div className="no-data-container">
				<div className="no-data-message">No course data available.</div>
			</div>
		);
	}

	return null;
};

export default CourseRedirect;
